import { render } from "./asc-loader.vue?vue&type=template&id=7456e2f7&scoped=true"
import script from "./asc-loader.vue?vue&type=script&lang=js"
export * from "./asc-loader.vue?vue&type=script&lang=js"

import "./asc-loader.vue?vue&type=style&index=0&id=7456e2f7&scoped=true&lang=scss"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7456e2f7"]])

export default __exports__